import DialogTrophy from '~/components/dialog/trophy/DialogTrophy.vue';
import { getServices } from '~/db/services';

export const useDialogTrophyFromHeader = () => {
  const { $db } = useNuxtApp();
  const { trophiesService, mediasService } = getServices($db);
  const dialog = useDialogStore();
  const { t } = useNuxtApp().$i18n;
  const open = async (ids: string[]) => {
    const id = ids.pop();
    await openDialog(id);
    if (ids.length > 0) {
      setTimeout(() => {
        open(ids);
      }, 1000);
    }
  };
  const openDialog = async (id: string) => {
    const trophy = await trophiesService.get({ id: id.trim() });
    if (!trophy) {
      return;
    }

    trophiesService.update(id, { ratioProgress: 1 });

    const { title, winTextField: label, icon } = trophy;

    const media = await mediasService.get({ id: icon });
    if (!media) {
      return;
    }

    return new Promise<void>((resolve) => {
      dialog.open(DialogTrophy, {
        level: DialogLevel.Reward,
        title: t('trophies.popin.revealed'),
        subTitle: title,
        label,
        onClose: () => {
          resolve();
        },
        imgUrl: media.url,
        progress: 1,
        buttonTrophies: true,
      });
    });
  };
  return {
    open,
  };
};
